import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, Field } from 'redux-form';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import RadioField from '../fields/RadioField';
import Heading from '../elements/PageHeading';
import renderError from '../elements/renderError';

import { types } from '../../utils/deviceTypes';
import { WIZARD_FORM_NAME } from '../../constants/common';
import { skipPage } from '../../actions/wizard';

const Form = styled.div`
  margin-top: 50px;
  text-align: center;
  margin-bottom: 30px;
`;

class DeviceSubTypePage extends Component {
  componentDidMount() {
    const { type } = this.props;
    const subTypes = types[type].subTypes;

    // If there are no multiple options select automatically
    if (subTypes.length < 2) {
      const subType = subTypes[0] || 'None';
      this.props.change('SubType', subType);
      this.props.skipPage();
    }
  }

  render() {
    const { t, type, handleSubmit } = this.props;
    const selectableSubTypes = types[type].subTypes.slice(0, 5); // getting only specific sub types.
    return (
      <React.Fragment>
        <Heading text={t('device_subtype.title')} />
        <Form onSubmit={handleSubmit}>
          <fieldset>
            {selectableSubTypes.map(type => (
              <RadioField
                key={type}
                name="SubType"
                type="radio"
                component="input"
                value={type}
                label={t(`device_subtype.${type}`)}
                data-device-type={type}
              />
            ))}
            <Field name="SubType" component={renderError} />
          </fieldset>
        </Form>
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(WIZARD_FORM_NAME);
const mapStateToProps = state => ({
  type: selector(state, 'Type'),
});

const mapDispatchToProps = {
  skipPage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(DeviceSubTypePage));
